'use strict';
const angular = require('angular');

export class newsFeedComponent {

  constructor(NewsService, IntegrationService, Config, Auth) {
    'ngInject';

    this.NewsService = NewsService;
    this.Config = Config;
    this.IntegrationService = IntegrationService;
    this.currentPage = 1;
    this.isAdmin = Auth.isAdminSync();
  }

  $onInit() {

    let convertShortcode = (html) => {
      return html.replace(/\[/g,"<").replace(/\]/g,">");
    };

    this.itemsPerPage = this.itemsPerPage || 4;

    if (this.featured) {
      this.itemsPerPage = this.Config.getPaginationWithDefault("featuredNews", 3);

      let types = this.type;
      if (types) {
        types = types.replace(/ /g, '').split(",");
      }

      let _data = [];

      this.NewsService.getFeatured(data => {
        if (types && types.length != 0) {
          _data = data.filter(news => types.includes(news.type));
        } else {
          _data = data;
        }

        _data.forEach(news => {
          news.body = convertShortcode(news.body);
        });

        if (this.master) {
          this.IntegrationService.getNews(data => {
            _data = _data.concat(data);

            this.data = _data.sort((a,b) => {
              return new Date(b.meta.creationDate) - new Date(a.meta.creationDate);
            });

          });
        } else {
          this.data = _data;
        }

      }, err => {
        console.log('could not load featured news');
      });

    } else {
      this.NewsService.getByType({type: this.type}, data => {
        this.data = data;
        this.data.forEach(news => {
          news.body = convertShortcode(news.body);
        });
      }, err => {
        console.log('Could not retrieve news posts');
      });
    }
  }
}

export default angular.module('conduuApp.newsFeed', [])
  .component('newsFeed', {
    template: require('./news-feed.component.html'),
    bindings: {
      itemsPerPage: '@',
      type: '@',
      featured: '<',
      master: '<'
    },
    controller: newsFeedComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/news-feed/news-feed.component.js